<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

// Cartão exibido no lugar de uma imagem ou vídeo marcado como impróprio. "Ver mesmo
// assim" revela apenas para quem clicou, nesta tela; nada muda para os demais agentes.
const props = defineProps({
  hiddenMedia: { type: Object, required: true },
  compact: { type: Boolean, default: false },
});
const emit = defineEmits(['reveal']);
const { t } = useI18n();

const description = computed(() => {
  const name = props.hiddenMedia?.hiddenByName;
  return name
    ? t('CONVERSATION.HIDDEN_MEDIA.DESCRIPTION', { name })
    : t('CONVERSATION.HIDDEN_MEDIA.DESCRIPTION_NO_NAME');
});
</script>

<template>
  <div
    v-if="compact"
    class="flex size-[72px] flex-col items-center justify-center gap-1 rounded-xl border border-n-weak bg-n-solid-1 p-1 text-center"
    :title="description"
    data-hidden-media
  >
    <Icon icon="i-hugeicons-view-off-slash" class="size-4 text-n-slate-11" />
    <button
      type="button"
      class="text-[11px] font-medium leading-tight text-n-brand hover:underline"
      @click.stop="emit('reveal')"
    >
      {{ t('CONVERSATION.HIDDEN_MEDIA.REVEAL') }}
    </button>
  </div>
  <div
    v-else
    class="flex w-60 min-w-0 max-w-full flex-col items-center gap-2 rounded-lg border border-n-weak bg-n-solid-1 px-3 py-4 text-center"
    role="note"
    data-hidden-media
  >
    <span
      class="grid size-9 place-content-center rounded-full bg-n-alpha-2 text-n-slate-11"
    >
      <Icon icon="i-hugeicons-view-off-slash" class="size-5" />
    </span>
    <strong class="text-sm text-n-slate-12">
      {{ t('CONVERSATION.HIDDEN_MEDIA.TITLE') }}
    </strong>
    <p class="mb-0 break-words text-xs text-n-slate-11">{{ description }}</p>
    <button
      type="button"
      class="text-xs font-medium text-n-brand hover:underline"
      :title="t('CONVERSATION.HIDDEN_MEDIA.REVEAL_HINT')"
      @click.stop="emit('reveal')"
    >
      {{ t('CONVERSATION.HIDDEN_MEDIA.REVEAL') }}
    </button>
  </div>
</template>
